<template>
	<Col :span="24">
		<TypographyTitle :level="3">{{ $t('settings.externalSources.header') }}</TypographyTitle>
		<Row :gutter="[16, 8]">
			<ExternalSourceForm v-if="isVisibleBrdc" label="brdc" />
			<ExternalSourceForm v-if="isVisibleSsr" label="ssr" />
		</Row>
	</Col>
</template>

<script>
import { computed } from 'vue';

import { TypographyTitle, Row, Col } from 'ant-design-vue';

import { useLicenseStore } from '@/stores/licenseStore';

import ExternalSourceForm from '@/components/settings/ExternalSourceForm';

export default {
	components: {
		TypographyTitle, Row, Col,
		ExternalSourceForm,
	},
	setup() {
		const licenseStore = useLicenseStore();
		const getVisibility = label => computed(() => licenseStore.allowExtSources.includes(label));
		return {
			licenseStore,
			isVisibleBrdc: getVisibility('brdc'),
			isVisibleSsr: getVisibility('ssr'),
		};
	},
}
</script>
